import PropTypes from 'prop-types';
import React, { createRef } from 'react';
import DynamicTextArea from '../../dynamic_text_area.jsx';
import classnames from 'classnames';

export default class extends React.PureComponent {
    static propTypes = {
        replyTo: PropTypes.func.isRequired,
        questionId: PropTypes.number.isRequired,
    };

    state = {
        disabled: true,
    };

    replyTextRef = el => {
        this.replyText = el;
    };

    componentDidMount() {
        this.focusOnInput();
    }

    onChange = event => {
        const disabled = event.target.value.length === 0;
        if (disabled !== this.state.disabled) {
            this.setState({
                disabled: disabled,
            });
        }
    };

    onSave = () => {
        const { replyTo, questionId } = this.props;
        const response = this.replyText.value;
        replyTo(questionId, response);
    };

    focusOnInput = () => {
        // need to find and set the scroll position, otherwise the viewport will jump
        const x = window.scrollX,
            y = window.scrollY;
        this.replyText.focus();
        window.scrollTo(x, y);
    };

    render() {
        const btnClasses = classnames({
            btn: true,
            'btn-primary': true,
            disabled: this.state.disabled,
        });

        return (
            <div>
                <DynamicTextArea
                    forwardedRef={this.replyTextRef}
                    placeholder="Reply Text"
                    required
                    onChange={this.onChange}
                />
                <button
                    className={btnClasses}
                    disabled={this.state.disabled}
                    onClick={this.onSave}
                >
                    Reply
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/text_viewer/highlight/note_reply.jsx